import {
    CREATE_PRODUCT_RELATED,
    CREATE_PRODUCT_RELATED_FAILURE,
    CREATE_PRODUCT_RELATED_SUCCESS,
} from 'store/actions/types';

export const createProductRelated = (payload) => {
    return {
        type: CREATE_PRODUCT_RELATED,
        payload: payload,
    };
};

export const createProductRelatedFailure = (error, productId) => {
    return {
        type: CREATE_PRODUCT_RELATED_FAILURE,
        error: error,
        productId: productId,
    };
};

export const createProductRelatedSuccess = (response) => {
    return {
        type: CREATE_PRODUCT_RELATED_SUCCESS,
        productId: response.product_id,
        response: response,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/products/related/createProductRelated.js